import type { Branded } from "@@/utilities/branded";
import { generateId } from "@@/utilities/generate-id";
import { z } from "zod";

type SaleId = Branded<string, "SaleId">;
const createSaleId = (): SaleId => generateId({ prefix: "sale__" });
const saleIdZodSchema = z
    .string()
    .regex(/^sale_.*$/) as unknown as z.ZodSchema<SaleId>;

export { createSaleId, saleIdZodSchema };
export type { SaleId };
